import firebaseChatService from '../services/firebaseChatService';
import { initApp } from './serverApi';
import { updateAllowInput, updateIsLcfMandatory } from './index';
import { lazyLoaders } from '../services/loading-scheduler';

export const onVisitorMerge = (event) => async (dispatch, getState) => {
  if (event.mergedIntoChatroomId) {
    dispatch(updateAllowInput(true));
  }

  dispatch(
    updateIsLcfMandatory({ ...getState().isLcfMandatory, isContact: true }),
  );
  void firebaseChatService.updatePresence({
    isContact: true,
  });

  if (
    !event.mergedIntoChatroomId ||
    event.mergedIntoChatroomId === event.visitorChatroomId
  ) {
    return;
  }

  const lazySdk = await lazyLoaders.interactivity.chatSdk();
  lazySdk.chatSdk.disconnect();

  return dispatch(
    initApp({
      reconnectData: {
        refresh: true,
        oldVisitorInstanceId: firebaseChatService.visitorInstanceId,
        prevChatToken: getState().coreChatToken,
      },
    }),
  );
};
